import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError, EMPTY } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment';

const AUTH_PATHS = ['/auth/login', '/auth/refresh'];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const apiBase = environment.api.baseUrl;
  const isApiCall = req.url.startsWith(apiBase);
  const isAuthCall = AUTH_PATHS.some((p) => req.url.includes(p));

  const token = authService.getAccessToken();
  const authReq =
    token && isApiCall && !isAuthCall
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req;

  return next(authReq).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status !== 401 || !isApiCall || isAuthCall) {
        return throwError(() => err);
      }

      return authService.refreshAccessToken().pipe(
        switchMap((newToken) => {
          if (!newToken) {
            authService.clearTokens();
            router.navigate(['/auth/login']);
            return EMPTY;
          }
          const retryReq = req.clone({ setHeaders: { Authorization: `Bearer ${newToken}` } });
          return next(retryReq);
        }),
      );
    }),
  );
};
